const colors = [
  {
    "CVO": 1,
    "DISEÑOS": "SHIFON YOLIS",
    "Color": "#1a1a1a #8a091f #ff3338 #c3e4f7 #fce2eb #fdedd6 #ffece5 #f6f7fc"
  },
  {
    "CVO": 2,
    "DISEÑOS": "D-211",
    "Color": "#f86003 #f86003 #edc3d7 #dce2ee #a9d1ea"
  },
  {
    "CVO": 3,
    "DISEÑOS": "INTER LUNA",
    "Color": "#1a1a1a #191919 #2a2c30 #0428ba"
  },
  {
    "CVO": 4,
    "DISEÑOS": "INTER KITTY",
    "Color": "#eff2f2 #f2f2f2 #eeeeee #ececf4"
  },
  {
    "CVO": 5,
    "DISEÑOS": "SONORA",
    "Color": "#191919 #540819 #fc5191 #1456b1 #1c1c1e #898d98 #888886 #cca296 #930e2d #0562bf #a174d1 #c55fb5 #f3599f #e1e2e7 #1e1f23"
  },
  {
    "CVO": 6,
    "DISEÑOS": "DETROIT",
    "Color": "#1c1d22 #fa0337 #f2f2f4 #191919"
  },
  {
    "CVO": 7,
    "DISEÑOS": "ORLANDO",
    "Color": "#5f4d29 #f02844 #0732d0 #29edef #fddcd5 #a2e4e1 #b3b4b8 #f7f7f9"
  },
  {
    "CVO": 8,
    "DISEÑOS": "MONTERREY",
    "Color": "#3b3233 #0272c8 #035ac4 #a19d5d #f98d44 #fd7d4e #fbd8dc #f0dbe2 #e0e0e8"
  },
  {
    "CVO": 9,
    "DISEÑOS": "ALAMO",
    "Color": "#655254 #098de0 #ff9d53 #1a1a1c"
  },
  {
    "CVO": 10,
    "DISEÑOS": "POLY SPUN",
    "Color": "#191a1e #1b517f #002db3 #79087e #ffdc57 #f4879a #f6c8bb #44bbb9 #34232d"
  },
  {
    "CVO": 11,
    "DISEÑOS": "QUIRURSATEX",
    "Color": "#d2deea #04d1f0"
  },
  {
    "CVO": 12,
    "DISEÑOS": "KENIA",
    "Color": "#1a1a1a #780130 #9b8b96 #e8dde1 #ab031f"
  },
  {
    "CVO": 13,
    "DISEÑOS": "BLIZZARD",
    "Color": "#9895a6 #b4b3b1 #480a1a #821a0f #3ad8f5 #f0d4d1 #858587"
  },
  {
    "CVO": 14,
    "DISEÑOS": "BAMBI",
    "Color": "#b00017 #087ab2 #fe0176 #eff0f5 #1a1a1a"
  },
  {
    "CVO": 15,
    "DISEÑOS": "IBIZA",
    "Color": "#0b2540 #1a1a18 #900ba3 #717195 #674947"
  },
  {
    "CVO": 16,
    "DISEÑOS": "GLACIAL C",
    "Color": "#151924 #b0b98a #aad6d7 #f6ee89 #fcd3cd #e2232f"
  },
  {
    "CVO": 17,
    "DISEÑOS": "PACIFICO ",
    "Color": "#7b0996 #fb8ea4 #65ded2 #fed0c1 #ffe605 #073ece"
  },
  {
    "CVO": 18,
    "DISEÑOS": "ARTICA",
    "Color": "#2d3219 #ab3413 #10263b #851eb3 #7f8598 #414143 #v #ed0f6f #0a4ec9 #0d989c #b9b6ca #3d0e1b #dbb8bc #a8aaa5"
  },
  {
    "CVO": 19,
    "DISEÑOS": "TIFANY BRUSH",
    "Color": "#1a1a1a #142245 #ff3389 #fdef8d #f7a78c #c59fd0 #facfc9 #99f5e6 #f8f7f3 #f6f1ed #f8b109"
  },
  {
    "CVO": 20,
    "DISEÑOS": "LONDON",
    "Color": "#3a382b #9f9b51 #17233b #00299a #fd4221 #db0028 #f78d80 #006ca1 #fa002c #fd8287 #edbc39 #01bbb0 #d9017e #fa40bb #191718"
  },
  {
    "CVO": 21,
    "DISEÑOS": "IMPACTO",
    "Color": "#19191b #3f2e34 #321c28 #17528e #0c4ddb #9b00a7 #f9a9b4 #41d5c5 #fbd6c3 #f1df4d #1e1e1e"
  },
  {
    "CVO": 22,
    "DISEÑOS": "BRILLALIN",
    "Color": "#c40b31 #ee9e9b #1b1b1b"
  },
  {
    "CVO": 23,
    "DISEÑOS": "ANTARTIDA",
    "Color": "#1f2f38 #1f2f38 #640b8b #017419 #fa1269 #fdc5c3 #fd6c13 #b907a0 #00a7cc #cb0839"
  },
  {
    "CVO": 24,
    "DISEÑOS": "SUPER PONTI",
    "Color": "#1a1a1a #534742 #281916 #cc082c #0934b9 #7c5143 #05b9d4 #e98b82 #976662 #1c1a1d"
  },
  {
    "CVO": 25,
    "DISEÑOS": "CAMILITA X",
    "Color": "#ac001e #fe7977 #032c4a #fe0130 #fab035 #fb015e #1a1a1a"
  },
  {
    "CVO": 26,
    "DISEÑOS": "BRUSELAS",
    "Color": "#1f232e #055381 #5e3438 #fb0f41 #0c41c4 #59562c #59562c #f7085d #f2898e #fca925 #fce16c #fadad8 #a7ede5 #f6f5f0 #ecedf2 #191919"
  },
  {
    "CVO": 27,
    "DISEÑOS": "VENECIA",
    "Color": "#ec0319 #f88800 #fb9006 #fc0019 #fccdc7 #efedf1 #f7b2ce"
  },
  {
    "CVO": 28,
    "DISEÑOS": "SHIFFON MOÑO",
    "Color": "#452621 #bf022b #f80744 #108b93 #b5b5b5 #cc9287 #fcded3 #f8c7c3 #e3e2dd"
  },
  {
    "CVO": 29,
    "DISEÑOS": "LICRA LUCIA",
    "Color": "#321419 #b1d7ec #fdd7e2 #fae3db #ff0004"
  },
  {
    "CVO": 30,
    "DISEÑOS": "EMPERADOR",
    "Color": "#1a1a1a #02204b #fcab96 #ffe0e5 #cfebdc #ffdcf4"
  },
  {
    "CVO": 31,
    "DISEÑOS": "PORTUGAL",
    "Color": "#36344a #11172d #5d512a #b2011d #f101b6 #fcca43 #fd66c7 #fba397 #b4d5f4 #1a1a1a"
  },
  {
    "CVO": 32,
    "DISEÑOS": "GORIZZIA",
    "Color": "#1a1a1a #064fda"
  },
  {
    "CVO": 33,
    "DISEÑOS": "OTTAWA",
    "Color": "#1d1d25 #1a1a1a #ff148c #f9ae87 #f1c1bd #f9d0ca #fee998 #e7d7e4 #1a1a1c"
  },
  {
    "CVO": 34,
    "DISEÑOS": "VARSOVIA",
    "Color": "#4b4e53"
  },
  {
    "CVO": 35,
    "DISEÑOS": "VISKY",
    "Color": "#7a0017"
  },
  {
    "CVO": 36,
    "DISEÑOS": "INTER 70",
    "Color": "#ececf8"
  },
  {
    "CVO": 37,
    "DISEÑOS": "PREMIER PESADO",
    "Color": "#fefefe"
  },
  {
    "CVO": 38,
    "DISEÑOS": "PREMIER LIGERO",
    "Color": "#f8f8fa"
  },
  {
    "CVO": 39,
    "DISEÑOS": "DUBLIN",
    "Color": "#1f1f1f #192741 #f61e36 #f3f4f9"
  },
  {
    "CVO": 40,
    "DISEÑOS": "FRENCH FIT COSMOS",
    "Color": "#6bc39d #e3117b #eac2c2 #ddc8c5 #e2dcce #dddee3"
  },
  {
    "CVO": 41,
    "DISEÑOS": "FRENCH TERRY FIT",
    "Color": "#181c28 #676131 #0776ad #00a2e5 #00c3c1 #890018 #f01646 #f06b1e #d68c33 #fad35a #fc0d84 #f6449a #ebb8b5 #82e2d6 #f6f5f0 #e8e9ee"
  },
  {
    "CVO": 42,
    "DISEÑOS": "ACRILICO BETA",
    "Color": "#4f4f51 #1b1b1d #3e2e21 #692b30 #d81823 #fbc950 #be8c6b #c69ca0 #a7a7a7"
  },
  {
    "CVO": 43,
    "DISEÑOS": "FRENCH TERRY MORO",
    "Color": "#181818 #ce0434 #151a2e #6be9dd #fee3c8 #fef06b #f2f2fa #181818"
  },
  {
    "CVO": 44,
    "DISEÑOS": "FRENCH TERRY EUREKA",
    "Color": "#383c45 #df94a9 #4f5048 #0ebcc7 #d60c34 #ee163d #e3a9a8 #1d1c21"
  },
  {
    "CVO": 45,
    "DISEÑOS": "FELPA MUNDIALISTA",
    "Color": "#1f232b #f94275 #232323"
  },
  {
    "CVO": 46,
    "DISEÑOS": "PIQUE ITALIA 30",
    "Color": "#383723 #523e33 #065168 #ffad88 #d44772 #b8a7dd #e8c5c3 #89afd4 #e5e5ed #686f77 #636b76 #492330 #625c46 #1b1b1b"
  },
  {
    "CVO": 47,
    "DISEÑOS": "PIQUE SICILIA",
    "Color": "#1a1a1a #361937 #ff3e70 #01cdde #fc6656 #fbbdd4 #ffefa4 #f5f5f7 #dfceba"
  },
  {
    "CVO": 48,
    "DISEÑOS": "PIQUE SUIZA",
    "Color": "#1a1a1a #ff9235 #71dce4 #eaebf0 #20232c"
  },
  {
    "CVO": 49,
    "DISEÑOS": "PIQUE WIN",
    "Color": "#292d48 #684f50 #bfc0c5 #e2e5ee #1b1b1b"
  },
  {
    "CVO": 50,
    "DISEÑOS": "D-285 CARDIGAN",
    "Color": "#1d1f2c #ed1449 #ffde7b #fe002b #ff9e97 #f5cac3 #b0f9f0 #ffe4e0 #fff19d #f1f2f6 #1a1a1a"
  },
  {
    "CVO": 51,
    "DISEÑOS": "CARDIGAN MINESSOTTA",
    "Color": "#363539 #0c66d3 #fa043c #800144 #fbdc55 #01a6ac #01a6ac #eed6de #e4e4ec #191919"
  },
  {
    "CVO": 52,
    "DISEÑOS": "CARDIGAN COSMOS 1X1",
    "Color": "#e1066a #9edbb8 #f4d6d6 #dadae2 #c4beaa"
  },
  {
    "CVO": 53,
    "DISEÑOS": "PARIS 393",
    "Color": "#1a1a1a #ff002b #f94135 #cccbd1 #96ecef #fcf0a8 #f5f6f8"
  },
  {
    "CVO": 54,
    "DISEÑOS": "RIB KOREA",
    "Color": "#152534 #a10211 #ea100e #673d08 #a88982 #5f6366"
  },
  {
    "CVO": 55,
    "DISEÑOS": "RIB TOKIO",
    "Color": "#39391c #0d2750 #461313 #66161e #601a22 #9d7d7b #a26e12 #551430 #068174 #c6448e #8b1737 #1e1f24"
  },
  {
    "CVO": 56,
    "DISEÑOS": "RIB SHANGAI",
    "Color": "#181d22 #e30230 #f82109 #fdb818 #ef6763 #fac6dc #fac6dc #e3e4de"
  },
  {
    "CVO": 57,
    "DISEÑOS": "NUEVO ESCOCIA",
    "Color": "#c87912 #e3b0af #c8cacd"
  },
  {
    "CVO": 58,
    "DISEÑOS": "DENIM ",
    "Color": "#121b2c #38404d #53678a #667588 #303747"
  },
  {
    "CVO": 59,
    "DISEÑOS": "BOMBAY",
    "Color": "#4f3f28 #1b5c94 #015dce #fd001c #04a0ac #04a0ac #02c0e4 #fce03f #2dd4d7 #b6e8e9 #c4c3c1 #191919"
  },
  {
    "CVO": 60,
    "DISEÑOS": "HOLANDA",
    "Color": "#56393d #1b1f2a #f5a6a6 #fefda4 #d4fea1 #e6e7ec #151515"
  },
  {
    "CVO": 61,
    "DISEÑOS": "HAMBURGO",
    "Color": "#f5f6fb"
  },
  {
    "CVO": 62,
    "DISEÑOS": "3D LINE",
    "Color": "#a28e89 #1a1a1a #868686"
  },
  {
    "CVO": 63,
    "DISEÑOS": "NITRO",
    "Color": "#191919 #171a26 #4b4046 #05b158 #065ecf #fe874a #ffce37 #f5f5f7"
  },
  {
    "CVO": 64,
    "DISEÑOS": "CAPRIATI HEAVY",
    "Color": "#131a24 #022686 #03b7ec #ffa0bc #fc94ab #d0fda2 #f6eade #e8e8f0 #1a1a1a"
  },
  {
    "CVO": 65,
    "DISEÑOS": "COLA DE SIRENA ",
    "Color": "#6c5958 #f629a9 #fdd34a #efeff9 #282627"
  },
  {
    "CVO": 66,
    "DISEÑOS": "*MEDELLIN ",
    "Color": "#eeedf5"
  },
  {
    "CVO": 67,
    "DISEÑOS": "BOGOTÁ",
    "Color": "#ff0101"
  },
  {
    "CVO": 68,
    "DISEÑOS": "MONTECARLO",
    "Color": "#ea0317"
  },
  {
    "CVO": 69,
    "DISEÑOS": "PIRAMAR",
    "Color": "#f8a209"
  },
  {
    "CVO": 70,
    "DISEÑOS": "CURACAO",
    "Color": "#d60260"
  },
  {
    "CVO": 71,
    "DISEÑOS": "RIALTO",
    "Color": "#40111b"
  },
  {
    "CVO": 72,
    "DISEÑOS": "MANAOS",
    "Color": "#191919 #1d212c #ea0531 #9f07b0 #0050c6 #fbc121 #fdeb6c #fee4d8 #75e7d7 #f4f4fc"
  },
  {
    "CVO": 73,
    "DISEÑOS": "PUNTO ROMA HORTENCIA",
    "Color": "#181818 #101731 #ff012d #fe0045 #ff9399 #ece2d8"
  },
  {
    "CVO": 74,
    "DISEÑOS": "SUPER TECHNO",
    "Color": "#1a1a1a"
  },
  {
    "CVO": 75,
    "DISEÑOS": "TECHNO COVID SATEX",
    "Color": "#f1f1ef"
  },
  {
    "CVO": 76,
    "DISEÑOS": "TECHNO NOVO",
    "Color": "#ebeaf2"
  },
  {
    "CVO": 77,
    "DISEÑOS": "SUPER PONTI NYLON",
    "Color": "#fc0225 #0728cb #222126 #6f665f #4a4a4c #bebfc1 #f8f7f5 #f6f6f6 #1a1a1a"
  }
];

export default colors;
